import React, { useState } from 'react';
import FormInput from '../components/ui/FormInput';
import Button from '../components/ui/Button';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
const Quote = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    interestedIn: '',
    comments: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would send the form data to a server
    console.log('Form submitted:', formData);
    setFormSubmitted(true);
  };
  const insuranceOptions = [{
    value: 'life',
    label: 'Life Insurance'
  }, {
    value: 'auto',
    label: 'Auto Insurance'
  }, {
    value: 'home',
    label: 'Home Insurance'
  }, {
    value: 'business',
    label: 'Business Insurance'
  }, {
    value: 'health',
    label: 'Health Insurance'
  }, {
    value: 'umbrella',
    label: 'Umbrella Insurance'
  }, {
    value: 'travel',
    label: 'Travel Insurance'
  }, {
    value: 'renters',
    label: 'Renters Insurance'
  }, {
    value: 'multiple',
    label: 'Multiple Policies'
  }];
  return <div className="w-full" data-id="element-491">
      {/* Page Header */}
      <section className="bg-[#0F1A2D] py-16 relative overflow-hidden" data-id="element-492">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-493"></div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-494">
          <h1 className="text-white font-bold mb-4" data-id="element-495">Get in Touch with Us</h1>
          <p className="text-white opacity-90 max-w-2xl mx-auto" data-id="element-496">
            Complete the form below and one of our advisors will contact you
            within 24 hours.
          </p>
        </div>
      </section>

      {/* Quote Form Section */}
      <section className="py-20" data-id="element-497">
        <div className="container mx-auto px-4" data-id="element-498">
          <div className="max-w-2xl mx-auto bg-white p-10 rounded-lg shadow-xl border border-gray-100" data-id="element-499">
            {formSubmitted ? <div className="text-center" data-id="element-500">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-501">
                  <CheckCircleIcon size={48} className="text-primary" data-id="element-502" />
                </div>
                <h2 className="font-bold mb-4 text-2xl" data-id="element-503">Thank You!</h2>
                <p className="text-text-secondary mb-8 leading-relaxed" data-id="element-504">
                  Your request has been successfully submitted. One of our
                  advisors will contact you within 24 hours to discuss your
                  needs and provide personalized recommendations.
                </p>
                <Button href="/" variant="secondary" className="group" data-id="element-505">
                  Return to Home
                  <ArrowRightIcon size={16} className="ml-2 group-hover:translate-x-1 transition-transform duration-200" data-id="element-506" />
                </Button>
              </div> : <>
                <div className="text-center mb-10" data-id="element-507">
                  <h2 className="font-bold mb-4 text-2xl" data-id="element-508">
                    Request a Consultation
                  </h2>
                  <p className="text-text-secondary leading-relaxed" data-id="element-509">
                    Please provide your information below, and we'll schedule a
                    personalized consultation to discuss your specific needs and
                    objectives.
                  </p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-510">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-511">
                    <FormInput label="First Name" name="firstName" required value={formData.firstName} onChange={handleChange} data-id="element-512" />
                    <FormInput label="Last Name" name="lastName" required value={formData.lastName} onChange={handleChange} data-id="element-513" />
                  </div>
                  <FormInput label="Email Address" type="email" name="email" required value={formData.email} onChange={handleChange} data-id="element-514" />
                  <FormInput label="Phone Number" type="tel" name="phone" required value={formData.phone} onChange={handleChange} data-id="element-515" />
                  <FormInput label="Interested In" type="select" name="interestedIn" required options={insuranceOptions} value={formData.interestedIn} onChange={handleChange} data-id="element-516" />
                  <FormInput label="Additional Information" type="textarea" name="comments" placeholder="Please provide any specific details about your needs or questions..." value={formData.comments} onChange={handleChange} data-id="element-517" />
                  <div className="pt-4" data-id="element-518">
                    <Button type="submit" className="w-full py-4" data-id="element-519">
                      Submit Request
                    </Button>
                  </div>
                  <p className="text-xs text-text-secondary mt-4 text-center" data-id="element-520">
                    By submitting this form, you agree to our Privacy Policy and
                    consent to being contacted regarding our services. We
                    respect your privacy and will never sell your information to
                    third parties.
                  </p>
                </form>
              </>}
          </div>
        </div>
      </section>
    </div>;
};
export default Quote;